import React from 'react'
import AboutMe from '../AboutMe/AboutMe';
import Banner from '../Banner/Banner';
import Blogs from '../Blogs';
import ContactMe from '../ContactMe';
import AllProjects from '../Projects';
import SentEmailForm from '../SentEmailForm';
import Services from './Services';
const Home = () => {
    return (
        <div>
            <div className='relative' >
                <Banner />
            </div>
            <div className='lg:px-20  md:px-10'>
                <AboutMe />
                <Services/>
                <AllProjects />
                <Blogs />
                <ContactMe />
                <SentEmailForm />
            </div>
        </div>
    );
};

export default Home;